module.exports = __webpack_public_path__ + "img/helical_right_gear.prt.d30dc675.jpg";